export const defaultIconSize = 32
export const defaultIconColor = "#E34752"
